export default __webpack_public_path__ + "static/media/Allergy.02c885a8.svg";